import React from "react";
import "./PcTran.css"

const PcTranOne = () => (
  <div className="INeedToOneMainDiv">

	<h1>Overview</h1>

	<p>URLs containing certain characters will display and link incorrectly 
    unless those characters are percent-encoded. PC-Tran is a percent code 
    translator. </p>

    <p>PC-Tran is annotated so that design documentation can be 
    created with <a href={"http://usejsdoc.org/"} 
    target={"_blank"}>JSDoc</a>.  The documentation created by
    the JSDoc tool can be seen  <a href={"https://pc-tran.charles-w-roberts.com/docs/"} 
    target={"_blank"}>here</a>.</p>

  </div>
);

export default PcTranOne;


// WEBPACK FOOTER //
// ./src/components/pctran/PcTranOne.js